'use client';

import clsx from 'clsx';

import { ChatSessionType } from '../types/ChatSessionType';

const TABS = [
  { value: ChatSessionType.Private, label: 'Private Messages' },
  { value: ChatSessionType.PrivatePromotional, label: 'Group Messages' },
] as const;

interface Props {
  value: ChatSessionType;
  onChange: (value: ChatSessionType) => void;
  className?: string;
}

/**
 * Controlled (local-state) Private / Group tab bar for the transient visitor
 * chat window launched from the bio "Message Me" button. The dashboard inbox
 * uses the URL-driven `ChatSessionTypeTabs`; here the window is a modal with no
 * route, so switching is plain state.
 */
export function ChatSessionTypeTabBar({ value, onChange, className }: Props) {
  return (
    <nav
      role="tablist"
      aria-label="Message type"
      className={clsx('flex items-center justify-center gap-6', className)}
    >
      {TABS.map(tab => {
        const active = tab.value === value;
        return (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.value)}
            className={clsx(
              '-mb-px border-b-2 py-2 text-sm font-semibold transition',
              active
                ? 'text-brand-text border-brand'
                : 'text-content-3 hover:text-content-2 border-transparent',
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </nav>
  );
}
